import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LogOut, User, Bell, Settings, PlusCircle } from 'lucide-react';
import { useCustomerAuth } from '../../contexts/CustomerAuthContext';
import '../../globals.css';

function CustomerHeader() {
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { customer, logout } = useCustomerAuth();

  const handleLogout = () => {
    logout();
    setShowDropdown(false);
  };

  return (
    <header className="premium-header">
      <div className="premium-header-container">
        {/* Logo */}
        <Link className="d-flex align-items-center gap-2" to="/" style={{ textDecoration: 'none' }}>
          <div className="d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', borderRadius: '8px', backgroundColor: '#185FA5' }}>
            <svg viewBox="0 0 24 24" fill="#FAC775" style={{ width: '20px', height: '20px' }}>
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
            </svg>
          </div>
          <span style={{ fontSize: '22px', fontWeight: 'bold', color: '#185FA5', marginLeft: '8px', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>SkillSeek</span>
        </Link>

        {/* Navigation links (Desktop) */}
        <nav className="premium-nav-links d-none d-md-flex">
          <Link className={`premium-nav-link ${location.pathname === '/' ? 'active' : ''}`} to="/">Home</Link>
          <Link className={`premium-nav-link ${location.pathname === '/about' ? 'active' : ''}`} to="/about">About Us</Link>
          <Link className={`premium-nav-link ${location.pathname === '/listing' || location.pathname === '/search' ? 'active' : ''}`} to="/listing">Services</Link>
          <Link className={`premium-nav-link ${location.pathname === '/contact' ? 'active' : ''}`} to="/contact">Contact Us</Link>
        </nav>

        {/* Customer actions */}
        <div className="d-flex align-items-center gap-3">
          <div className='customer-actions d-flex align-items-center gap-3' style={{ margin: 0 }}>
            <div className="notification-icon" style={{ cursor: 'pointer', margin: 0 }}>
              <Bell size={20} />
              <span className="notification-badge">0</span>
            </div>
            
            <div className="customer-profile position-relative" style={{ cursor: 'pointer' }} onClick={() => setShowDropdown(!showDropdown)}>
              <div className="customer-avatar">
                <User size={18} />
              </div>
              <span className="customer-name d-none d-sm-inline">
                {customer?.firstName || 'Customer'}
              </span>
              
              {showDropdown && (
                <div className="customer-dropdown" style={{ display: 'block' }}>
                  <Link to="/customer/dashboard" className="dropdown-item" onClick={() => setShowDropdown(false)}>
                    <User size={16} />
                    Dashboard
                  </Link>
                  <Link to="/customer/dashboard#profile" className="dropdown-item" onClick={() => setShowDropdown(false)}>
                    <Settings size={16} />
                    Profile Settings
                  </Link>
                  <button onClick={handleLogout} className="dropdown-item logout-item">
                    <LogOut size={16} />
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Mobile menu toggle */}
          <button 
            className="d-md-none btn p-2 rounded-lg" 
            style={{ backgroundColor: '#185FA5', color: '#ffffff', border: 'none' }}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {mobileMenuOpen ? (
                <line x1="18" y1="6" x2="6" y2="18"></line>
              ) : (
                <>
                  <line x1="4" y1="12" x2="20" y2="12"></line>
                  <line x1="4" y1="6" x2="20" y2="6"></line>
                  <line x1="4" y1="18" x2="20" y2="18"></line>
                </>
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Nav Links dropdown */}
      {mobileMenuOpen && (
        <div className="d-md-none position-absolute w-100 bg-white border-bottom" style={{ top: '57px', left: 0, zIndex: 999, padding: '16px 24px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
          <nav className="d-flex flex-column gap-3">
            <Link className={`premium-nav-link ${location.pathname === '/' ? 'active' : ''}`} to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link>
            <Link className={`premium-nav-link ${location.pathname === '/about' ? 'active' : ''}`} to="/about" onClick={() => setMobileMenuOpen(false)}>About Us</Link>
            <Link className={`premium-nav-link ${location.pathname === '/listing' || location.pathname === '/search' ? 'active' : ''}`} to="/listing" onClick={() => setMobileMenuOpen(false)}>Services</Link>
            <Link className={`premium-nav-link ${location.pathname === '/contact' ? 'active' : ''}`} to="/contact" onClick={() => setMobileMenuOpen(false)}>Contact Us</Link>
          </nav>
        </div>
      )}
    </header>
  );
}

export default CustomerHeader; 